import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApplicationActions } from './application.actions';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.state';
import { selectSession } from 'src/app/core/session/session.selectors';
import { map } from 'rxjs';
import { SessionState } from 'src/app/core/api/responses/get-accesso-pay-session';
import { routeToRedirectResultAction } from '../billing/billing.actions';
import { routeTo } from 'src/app/core/routing/routing.actions';

@Injectable()
export class ApplicationEffects {
  loadApplications$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ApplicationActions.loadApplications),
      concatLatestFrom(() => this.store.select(selectSession)),
      map(([_, session]) => {
        // returning from redirect payment
        if (session.type === SessionState.REDIRECT) {
          return routeToRedirectResultAction();
        }
        // otherwise, go to first page
        return routeTo({ payload: ['delivery'] });
      })
    );
  });

  constructor(private actions$: Actions, private store: Store<AppState>) {}
}
